var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack } from "@mui/material";
var SaveCancelActions = function (_a) {
    var onSave = _a.onSave, onCancel = _a.onCancel, _b = _a.saveButtonText, saveButtonText = _b === void 0 ? "Save" : _b, _c = _a.cancelButtonText, cancelButtonText = _c === void 0 ? "Cancel" : _c, _d = _a.isSaving, isSaving = _d === void 0 ? false : _d, _e = _a.IsDisableSaveButton, IsDisableSaveButton = _e === void 0 ? true : _e;
    return (_jsxs(Stack, __assign({ direction: "row", spacing: 2, justifyContent: "flex-end", mt: 2 }, { children: [_jsx(Button, __assign({ variant: "outlined", onClick: onCancel, className: "ST_Common_Button_Style", disabled: isSaving }, { children: cancelButtonText })), _jsx(Button, __assign({ variant: "contained", color: "primary", type: "button", className: "ST_Common_Button_Style", onClick: onSave, disabled: isSaving || !IsDisableSaveButton }, { children: isSaving ? "Saving..." : saveButtonText }))] })));
};
export default SaveCancelActions;
